// extracted by mini-css-extract-plugin
export default {"container":"RelationList_container__KWI7a","title":"RelationList_title__5COZy","list":"RelationList_list__Z0gbg","item":"RelationList_item__5shok"};